import Skeleton from '@mui/material/Skeleton';
import { useLifeAreaById } from 'features/life-areas';
import React from 'react';
import { useParams } from 'react-router';
import { IconFormIcons } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './page-top-bar.style';

export const LoadingTitle: React.FC = () => (
  <Skeleton animation="wave" width="100%" height="1.8rem" />
);

export const Title: React.FC = () => {
  const { id } = useParams();
  const lifeArea = useLifeAreaById(id);

  return lifeArea ? (
    <Styled.TitleContainer>
      <Styled.IllustrationContainer $color={undefined}>
        <Styled.IconContainer>
          <Icon icon={IconFormIcons[lifeArea.iconName]} />
        </Styled.IconContainer>
      </Styled.IllustrationContainer>

      <Styled.Title>{lifeArea.name}</Styled.Title>
    </Styled.TitleContainer>
  ) : null;
};
